import { useState } from "react";
import LeadershipAPI from "../../../api/LeadershipAPI";

const useApproveRejectMilestone = () => {
	const [loading, setLoading] = useState(false);

	const approveReject = async (data) => {
		setLoading(true);

		try {
			const result = await LeadershipAPI.approveRejectMilestone(data);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to delete request:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		approveReject,
		loading,
	};
};

export default useApproveRejectMilestone;
